import { z } from 'zod';
import { route, defineContract } from '../core/types';

export const translationsContract = defineContract('translations', {
	uploadTranslationsFile: route({
		method: 'POST',
		path: '/',
		contentType: 'multipart/form-data',
		body: z.object({
			file: z.file(),
		}),
		response: z.string(),
		operationId: 'uploadTranslationsFile',
		tags: ['Translations Storage'],
		summary: 'Upload translations CSV file',
	}),
	getTranslations: route({
		method: 'GET',
		path: '/',
		response: z.any(),
		operationId: 'getTranslations',
		tags: ['Translations Storage'],
		summary: 'Get translations CSV content',
	}),
});
